import { render } from "./CryptosCreep.vue?vue&type=template&id=3c55451b&scoped=true&ts=true"
import script from "./CryptosCreep.vue?vue&type=script&lang=ts"
export * from "./CryptosCreep.vue?vue&type=script&lang=ts"

import "./CryptosCreep.vue?vue&type=style&index=0&id=3c55451b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c55451b"]])

export default __exports__